import debounce from 'debounce';

import { UrlAdaptor } from '@syncfusion/ej2-data';

import { redirectErrorStatus } from '@/front/fetch';

// Patch UrlAdaptor to set Accept header to application/json (not */*)
UrlAdaptor.prototype.beforeSend = (_dm, request) => {
  request.headers.set('Accept', 'application/json');
};

// Patch XMLHttpRequest to redirect error statuses to appropriate page
// @ts-ignore
XMLHttpRequest.prototype.send_ = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function (body) {
  this.addEventListener(
    'readystatechange',
    debounce(() => {
      if (!this.responseURL.startsWith('https://beaconapi.helpscout.net')) {
        redirectErrorStatus(this.status);
      }
    }),
  );
  // @ts-ignore
  this.send_(body);
};
